<template>
  <div v-click-outside="toggleOff"
    class="installment-select-wrapper"
    :class="{ mobile: isMobile() }">
    <div
      v-show="showSelect"
      :class="['installment-options', { mobile: isMobile() }]"
      v-apply-theme
    >
      <div
        @click="() => onSelect(i)"
        @tap="() => onSelect(i)"
        class="installment-option"
        :class="[
          { desktop: !isMobile() },
        ]"
        v-for="(el, i) in installments"
        :key="i"
        :value="el._id"
      >
        <asset-v-3
          dir="icons"
          name="check-small.svg"
          :style="`visibility: ${indexSelected === i ? 'visible' : 'hidden' }`"
        />
        <div class="installment-option-value"
          :class="{ desktop: !isMobile() }"
        >
          {{ el.numberOfInstallments }} vezes de
          {{ el.paymentInstallments | moneyFilter }}
        </div>
      </div>
    </div>
    <div
      :class="[
        'installment-select-button',
        { mobile: isMobile() },
      ]"
      v-apply-theme
      @click="toggle"
      @tap="toggle"
    >
      <span :class="[
        { skeleton: loading },
      ]">{{ selectedText || 'Selecione' }}</span>
      <chevron-down-icon class="angle-icon"/>

    </div>
  </div>
</template>

<script>
import { ChevronDownIcon } from '@vue-hero-icons/solid';
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';
import { ApplyTheme } from '@/directives/applyTheme';
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  name: 'installment-select',
  data: () => ({
    showSelect: false,
  }),
  components: { ChevronDownIcon, AssetV3 },
  directives: {
    ApplyTheme,
  },
  computed: {
    selected() {
      if (typeof this.indexSelected !== 'number') return null;
      return this.installments[this.indexSelected];
    },
    selectedText() {
      if (this.selected) {
        const el = this.selected;
        if (this.isMobile()) {
          return `
          ${el.numberOfInstallments}x de
          ${this.moneyFilter(el.paymentInstallments)}`;
        }
        return `
          ${el.numberOfInstallments}x de
          ${this.moneyFilter(el.paymentInstallments)}`;
      }
      return null;
    },
  },
  methods: {
    toggleOff() {
      this.showSelect = false;
    },
    toggle() {
      this.showSelect = !this.showSelect;
    },
    onSelect(index) {
      this.toggle();
      this.$emit('installmentSelect', index);
    },
  },
  mounted() {
    if (typeof this.indexSelected === 'number' && this.indexSelected >= 0) this.$emit('installmentSelect', this.indexSelected);
  },
  props: {
    installments: {
      type: Array,
      required: true,
    },
    indexSelected: {
      type: Number,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [StringMixin, UtilMixin],
};
</script>

<style scoped lang="scss">
.installment-select {
  @extend .body-regular;
  vertical-align: middle;
  text-align: center;
  padding: 7px;
}

.installment-select-wrapper, .installment-select-button {
  width: fit-content;
  display: inline-block;
  position: relative;
  &.mobile {
    width: 100%;
  }
}

.installment-select-button {
  @extend .small-regular;
  background-color: var(--white);
  border: 1px solid var(--gray-300);
  box-sizing: border-box;
  width: fit-content;
  border-radius: 6px;
  padding: 7px 16px;
  cursor: pointer;

  span {
    color: var(--gray-900);
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }

  &--vivo {
    font-weight: 200 !important;
    width: 100%;
    max-width: 405px;
    height: 56px;
    line-height: 28px;
    justify-content: space-between;
    padding: 10px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &.mobile {
    width: 100%;
    cursor: initial;
  }
}

.angle-icon {
  float: right;
}

.installment-options {
  cursor: pointer;
  position: absolute;
  background-color: var(--white);
  z-index: 2;
  border: 1px solid var(--gray-300);
  box-sizing: border-box;
  box-shadow: 0px 4px 6px -4px rgba(24, 39, 75, 0.12), 0px 8px 8px -4px rgba(24, 39, 75, 0.08);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  width: fit-content;
  min-width: 240px;
  top: 100%;

  &--vivo {
    margin-top: 10px;
    > * {
      padding-top: 10px;
    }
  }

  &.mobile {
    border-radius: 6px;
    box-shadow: 0px -2px 16px rgba(0, 0, 0, 0.3);
    top: 100%;
    /* bottom: -100%; */
    left: 0;
    right: 0;
    width: 100%;
    transition-duration: 0.2s;
    transition-timing-function: ease-out;
    &.slide {
      bottom: 0;
    }
  }
}

.installment-option {
  display: flex;
  padding: 8px 12px;
  border-top: 1px solid var(--gray-200);
  gap: 4px;

  &.desktop {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &:hover {
    background-color: var(--gray-100);
  }

  &:first-child:hover {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  &:last-child:hover {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
}

.installment-option-value {
  color: var(--gray-900);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  &.desktop {
    padding-right: 8px;
    white-space: nowrap;
  }
}

.installment-option-interest {
  @extend .x-small-regular;
  @extend .gray-400;
  &.desktop {
    white-space: nowrap;
  }
}

</style>
